export const nuvemEnvioLabelsAppLinkPrefixes = [
  'nuvem-envio-app-back',
  'services-ne-app-back',
];

export const NUVEM_ENVIO_CARRIERS = ['nuvem-envio', 'envio-nube'];
export const MANUAL_ORDER_TYPES = ['table', 'draft'];
